import React from 'react';
import { IonButton, IonAlert } from '@ionic/react';

interface StartEndControlsProps {
  isRunning: boolean;
  showStartAlert: boolean;
  setShowStartAlert: (b: boolean) => void;
  showEndAlert: boolean;
  setShowEndAlert: (b: boolean) => void;
  handleStartTraining: () => void;
  handleEndTraining: () => void;
  confirmEndTraining: (shouldEnd: boolean, isCancel?: boolean) => void;
}

const StartEndControls: React.FC<StartEndControlsProps> = ({
  isRunning,
  showStartAlert,
  setShowStartAlert,
  showEndAlert,
  setShowEndAlert,
  handleStartTraining,
  handleEndTraining,
  confirmEndTraining,
}) => {
  return (
    <>
      {/* End Training as advisor-card above */}
      {isRunning && (
        <div className="advisorCard trainingProgressCard">
          <div className="trainingProgressCard__mascot" aria-hidden="true">
            <span className="trainingProgressCard__glow" />
            <img
              src="/assets/ploppy/ploppy-running.png"
              alt=""
              className="trainingProgressCard__image"
            />
            <span className="trainingProgressCard__shadow" />
          </div>
          <div className="advisorCardTitle">Training in progress</div>
          <div className="advisorCardSub">
            Finish when you’re done. Or rage-cancel the whole thing if life
            happens.
          </div>

          <IonButton
            className="advisorCardBtn"
            expand="block"
            onClick={handleEndTraining}
          >
            End training
          </IonButton>
        </div>
      )}

      {/* Start Training (only when not running) */}
      {!isRunning && (
        <div className="startCard">
          <IonButton expand="block" onClick={() => setShowStartAlert(true)}>
            Start training
          </IonButton>
        </div>
      )}

      {/* Start confirm */}
      <IonAlert
        isOpen={showStartAlert}
        onDidDismiss={() => setShowStartAlert(false)}
        header="Start Training?"
        message="Start a new training session now?"
        buttons={[
          { text: 'Cancel', role: 'cancel' },
          {
            text: 'Start',
            handler: () => handleStartTraining(),
          },
        ]}
      />

      {/* End confirm */}
      <IonAlert
        isOpen={showEndAlert}
        onDidDismiss={() => setShowEndAlert(false)}
        header="End Training?"
        message="Do you want to end this training session?"
        buttons={[
          {
            text: 'Keep going',
            role: 'cancel',
            handler: () => confirmEndTraining(false),
          },
          {
            text: 'Cancel session',
            handler: () => confirmEndTraining(false, true),
          },
          {
            text: 'Save session',
            handler: () => confirmEndTraining(true),
          },
        ]}
      />
    </>
  );
};

export default StartEndControls;
